// Phase H.12a — Page number inline atom nodes.
//
// Two inline atoms that only make sense inside the running header/footer:
//   - PageNumberNode      → `<span class="page-number"></span>`
//   - PageNumberTotalNode → `<span class="page-number-total"></span>`
//
// WeasyPrint replaces the empty content of these spans with CSS:
//   .page-number::before        { content: counter(page); }
//   .page-number-total::before  { content: counter(pages); }
// In the editor we render them as small styled chips so the user can see the
// placeholder.

import { Node, mergeAttributes } from "@tiptap/core";

export const PageNumberNode = Node.create({
    name: "pageNumber",
    group: "inline",
    inline: true,
    atom: true,
    selectable: true,

    parseHTML() {
        return [{ tag: "span.page-number" }];
    },

    renderHTML({ HTMLAttributes }) {
        return [
            "span",
            mergeAttributes(HTMLAttributes, {
                class: "page-number",
                "data-page-number": "true",
                spellcheck: "false",
            }),
            // Editor preview content. The PDF renderer's CSS replaces this
            // via `::before { content: counter(page); }` so the static "#"
            // is never seen in the rendered PDF.
            "#",
        ];
    },

    renderText() {
        return "#";
    },

    addCommands() {
        return {
            insertPageNumber:
                () =>
                ({ commands }) =>
                    commands.insertContent({ type: this.name }),
        };
    },
});

export const PageNumberTotalNode = Node.create({
    name: "pageNumberTotal",
    group: "inline",
    inline: true,
    atom: true,
    selectable: true,

    parseHTML() {
        return [{ tag: "span.page-number-total" }];
    },

    renderHTML({ HTMLAttributes }) {
        return [
            "span",
            mergeAttributes(HTMLAttributes, {
                class: "page-number-total",
                "data-page-number-total": "true",
                spellcheck: "false",
            }),
            "N",
        ];
    },

    renderText() {
        return "N";
    },

    addCommands() {
        return {
            insertPageNumberTotal:
                () =>
                ({ commands }) =>
                    commands.insertContent({ type: this.name }),
            insertPageOfTotal:
                () =>
                ({ commands }) =>
                    commands.insertContent([
                        { type: "text", text: "Page " },
                        { type: "pageNumber" },
                        { type: "text", text: " of " },
                        { type: "pageNumberTotal" },
                    ]),
        };
    },
});

export default PageNumberNode;
